const LOAD_DATA_BANK           = 'LOAD_DATA_BANK'
const LOAD_DATA_BANK_SUCCESS   = 'LOAD_DATA_BANK_SUCCESS'
const LOAD_DATA_BANK_FAILED    = 'LOAD_DATA_BANK_FAILED'
const UNMOUNT_DATA_BANK        = 'UNMOUNT_DATA_BANK'

const initialState = {
  loading: true,
  data: null,
  message: null,
  pagination: {
    page: 1,
    total: 0,
    perpage: 10
  }
}

const bankReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_BANK:
      return {
        ...state,
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case LOAD_DATA_BANK_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        pagination: {
          total: action.payload.pagination.total,
          page: action.payload.pagination.page,
          perpage: action.payload.pagination.perpage
        }
      }
    case LOAD_DATA_BANK_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    case UNMOUNT_DATA_BANK:
      return { 
        ...state, 
        loading: true,
        data: null,
        pagination: {
          page: 1,
          total: 0,
          perpage: 10
        }
      }
    default:
      return state
  }
}

export default bankReducer;